import React, { useState, useEffect } from "react";
import { useRouter } from 'next/router';

// styles
import styles from 'styles/our-methodology.module.scss'

// components
import { Button, Col, Row, Spacer, VStack } from 'avena-components';
import Image from 'next/image';

import ContactUsForm from "components/contact-us-form";

const details = [
    {
        header_1: 'Dedicated',
        header_2: 'teams',
        body: 'You are given a Product Manager, Tech Lead, Developers and a UX Specialist.',
        alt: 'dedicated_teams',
        img: '/card_image_1.webp',
    },
    {
        header_1: 'Daily',
        header_2: 'communication',
        body: 'Our Delivery system ensures proactive updates, which means you are never in the dark.',
        alt: 'daily_communication',
        img: '/card_image_2.webp'
    },
    {
        header_1: 'Rapid',
        header_2: 'executions',
        body: 'Our weekly sprints help in prioritizing tasks and focus on building the MVP fast.',
        alt: 'rapid_executions',
        img: '/card_image_3.webp'
    },
    {
        header_1: 'Predictable Return on',
        header_2: 'Investment (ROI)',
        alt: 'roi',
        body: 'Our process management gives you predictable measures to plan a solid product launch.',
        img: '/card_image_4.webp'
    },
]

const OurMethodology = () => {
    const router = useRouter();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
            window.addEventListener('resize', () => {
                if (window.innerWidth < 768) {
                    setIsMobile(true);
                } else {
                    setIsMobile(false);
                }
            });
        }
    }, []);
    return (
        <VStack className={styles.container}>
            <Row className={styles.section_1}>
                <div className={styles.background}>
                    {
                        isMobile ?
                            <Image width={391} height={372} priority src='/background_1_mobile.webp' alt="our_methodology_background_1_mobile" className={styles.background_image} />
                            :
                            <Image width={1920} height={538} priority src='/background_1.webp' alt="our_methodology_background_1_web" className={styles.background_image} />
                    }
                </div>
                <VStack className={styles.text_box}>
                    <div className={styles.inner_text_box}>
                        <div className={styles.body}>Our Methodology</div>
                        <div className={styles.header}>At Avena, we don’t just talk about great products.</div>
                    </div>
                    <div className={styles.body}>We make them with our clients.</div>
                </VStack>
            </Row>
            <Row className={styles.section_2}>
                <Col xs={24} sm={24} md={24} lg={10} xl={12} className={styles.first_column}>
                    <div className={styles.header}>At AVENA, we agile your products to success.</div>
                    <div className={styles.body}>After a definite period of time, through the agile way, you don’t just get one, but multiple functionalities of your product. To achieve this, Developers, Designers, and Testers work simultaneously and co-dependently.</div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={10} xl={12}>
                    <Image width={607} height={381} src='/background_2.webp' alt="our_methodology_background_2_web" className={styles.background_image} />
                </Col>
            </Row>
            <Row className={styles.section_3}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} className={styles.first_column}>
                    <VStack className={styles.text_container} style={{ gap: '37px', marginTop: '62px' }}>
                        <div className={styles.header}>Every functionality or module is divided by us into sprints, within which we cross out elements one after another.</div>
                        <div className={styles.body}>To ensure that everything is aligned with the project expectation, we have daily scrum meetings with the team, where the tasks are assigned.</div>
                    </VStack>
                    <Spacer />
                    <Button className={styles.button} onClick={() => router.push('/our-methodology/#contact-us')}>Contact Us</Button>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} className={styles.second_column}>
                    <Image width={660} height={445} src='/background_3.webp' alt="our_methodology_background_3_web" className={styles.image} />
                </Col>
            </Row>
            <VStack className={styles.section_4}>
                <VStack className={styles.column}>
                    <div className={styles.quote_container}>
                        <Image width={40} height={40} src='/quotes.webp' alt="quotes_icon" className={styles.quotes} />
                    </div>
                    <div className={styles.header}>We believe Agile is a mindset.</div>
                    <div style={{ justifyContent: 'flex-end' }} className={styles.quote_container}>
                        <Image width={40} height={40} src='/back-quotes.webp' alt="back_quotes_icon" className={styles.quotes} />
                    </div>
                </VStack>
                <div className={styles.hr} />
                <div className={styles.body}>
                    Our cross-functional teams evolve through collaborative effort to build the desired product. Design and Implementation go hand in hand, we welcome feedback and quickly adapt to change.
                </div>
            </VStack>
            <VStack className={styles.section_5}>
                <div className={styles.background} />
                <div className={styles.body_1}>We start by breaking the app development cycle into different tasks. These tasks are divided again into subtasks, each of which is performed simultaneously after being assigned to our teams.</div>
                <div className={styles.body_2}>At Avena, we don’t just talk about great products. </div>
                <div className={styles.header}>We make them with our clients.</div>
                <Row className={styles.row}>
                    {details.map( (el, ind) => (
                        <Col key={ind} xs={24} sm={24} md={24} lg={12} xl={12} className={styles.card}>
                            <Image width={663} height={475} src={el.img} className={styles.img} alt={el.alt} />
                            <div className={styles.bottom_container}>
                                <div className={styles.header}>{el.header_1}</div>
                                <div className={styles.header}>{el.header_2}</div>
                                <div className={styles.body}>{el.body}</div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </VStack>
            <ContactUsForm />
        </VStack>
    );
};

OurMethodology.role = 'Authenticated';

export default OurMethodology;
